/* This was extracted from newEvent dialog, so that's where the initial output of select an account comes from */
import { Component,  EventEmitter, Input, Output } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { OnInit } from '@angular/core';
import { Wrapper } from '../wrapper.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PhotoComponent } from '../photo';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { JoiAccount } from 'globals/store/accounts.data';
import { accountSelectorDialogSelector } from 'src/app/store/reselectors/accounts.reselector';

@Component({
    selector: 'account-selector',
    template: `
<ng-container *ngIf="!!selectedAccount">
  <div  class="label">{{ title }}</div>
  <div *ngIf="accounts.length === 1" class="para flex">
    <photo [data]="selectedAccount"></photo>
    <div class="name">{{selectedAccount.title}}</div>
  </div>
  <div *ngIf="accounts.length > 1" class="para">
    <div [matMenuTriggerFor]="useAccount" class="dropdown_label">
      <photo [data]="selectedAccount"></photo>
      <div class="name">{{selectedAccount.title}}</div>
      <icon class="drop" matIcon="arrow_drop_down"></icon>
    </div>
    <mat-menu #useAccount="matMenu" xPosition="before">
      <button *ngFor="let acc of accounts"
        mat-menu-item (click)="selectAccount(acc)"
        [disabled]="acc.is_invited"
      > {{acc.title || acc.id}}</button>
    </mat-menu>
  </div>
</ng-container>
`,
    styles: [`
  .para { margin-bottom: 15px; }
  .flex { display: flex; }
  .label { font-size:11px; font-weight:bold; color:#999; text-transform:uppercase; padding-bottom: 5px; }
  .name { line-height: 21px; }
  .dropdown_label, .drop { display: inline-flex; cursor: pointer; width: fit-content; align-items: center; }
`],
    standalone: true,
    imports: [MatMenuModule, MatButtonModule, MatIconModule, PhotoComponent, IconComponent, CommonModule],
})
export class AccountSelectorComponent extends Wrapper<AccountSelectorComponent> implements OnInit {
  @Output() initialAutoSelection: EventEmitter<JoiAccount> = new EventEmitter()
  @Output() dropdownSelection: EventEmitter<JoiAccount> = new EventEmitter()
  @Input() title = 'Account'
  @Input() contributorOK = true
  accounts: JoiAccount[]
  selectedAccount: JoiAccount

  ngOnInit() {
    // directly extracted / modified from newEvent.  Easier than reworking for now
    const selector = this.contributorOK ? accountSelectorDialogSelector : accountSelectorDialogSelector;
    this.subCallback(this.store.select(selector), ({ accountList, defaultAccount }) => {
      if (!accountList.length) return
      this.accounts = accountList
      this.selectedAccount = defaultAccount || accountList[0]
      this.initialAutoSelection.emit(this.selectedAccount)
    })
  }

  selectAccount(account: JoiAccount) {
    this.selectedAccount = account
    this.dropdownSelection.emit(account)
  }
}

